import { useAppSelector } from "redux/hooks";
import { selectClientLens } from "redux/slices/clientLens";
import BreadcrumbDropdownPicker, { type BreadcrumbDropdownPickerOption } from "./BreadcrumbDropdownPicker";
import { selectLenses } from "redux/slices/client";
import { EllipsisSX } from "theme";
import { CSSProperties } from "react";
import { AppRoutes } from "AppRoutes";

export const LensHomeBreadcrumb = () => {
  const clientLens = useAppSelector(selectClientLens);
  const lensOptions = useAppSelector(selectLenses);

  const options: BreadcrumbDropdownPickerOption[] = lensOptions.map((lens) => {
    return {
      title: lens.name,
      route: AppRoutes.lensHomeBuilder(lens.id),
      uniqueId: lens.id.toString(),
    };
  });

  return (
    <BreadcrumbDropdownPicker
      pendoId="breadcrumb-lens-picker::lensId"
      search={false}
      label={clientLens.name}
      options={options}
      noResultsText={undefined}
      currentRoute={AppRoutes.lensHomeBuilder(clientLens.id)}
      key="lenshome"
      sx={{
        ".MuiButtonBase-root": {
          width: "100%",
          ".MuiTypography-root": EllipsisSX as CSSProperties,
        },
      }}
    />
  );
};
